

jQuery(document).ready(function () {

    set_banner_header_spacing();

    jQuery(window).on("resize", function () {
        set_banner_header_spacing();
    });

});


set_banner_header_spacing = function () {
    if (jQuery('.header-banners-container-top').length) {
        header = jQuery('.header-block');
        if (header.hasClass('transparent')) {
            setTimeout(function () {
                top_banners = jQuery('.header-banners-container-top .header-banners');
                // before page
                jQuery('.header-placeholder').css('height', top_banners.height());
                // position the bottom banners
                //jQuery('.header-banners-container-bottom').css('height', (top_banners.height() + header.height()));

                main_header = header.find('.main-header');

                header.find('.sub-nav-container-outer, .header-mobile-container').css('top', (top_banners.height() + main_header.height()));

                section = jQuery('body').find('section').first();
                section.find('div').first().css('padding-top', (jQuery('.header-banners-container-bottom').height() + main_header.height()));
            }, 200)
        } else {
            jQuery('.header-placeholder').css('height', header.height());
        }
    }

    banner_countdown()
}

/// Language banner
/*
jQuery(document).ajaxComplete(function (event, request, settings) {

    const lang_box = jQuery('.banner-langs-select .lang-box');
    const lang_box_list_li = jQuery('.banner-langs-select .lang-box-list li');

    lang_box.on('click', function () {
        if (lang_box.hasClass('active')) {
            lang_box.removeClass('active');
        } else {
            lang_box.addClass('active');
        }
    });

    lang_box_list_li.on('click', function () {
        var url = jQuery(this).attr('data-url');
        var name = jQuery(this).attr('data-name');
        lang_box.attr('data-url', url);
        lang_box.find('span.text').text(name);
        lang_box.removeClass('active');
    });

    jQuery('.banner-langs-select #continue').on('click', function () {
        $redirect_url = lang_box.attr('data-url');
        window.location.href = $redirect_url;
    });

    jQuery('.banner-langs-select #close').on('click', function () {
        jQuery('.banner-langs-select').remove();
        set_banner_header_spacing();
        setLangBannerSession();
    });
});
*/
jQuery(document).on('click', '.banner-langs-select .lang-box', function () {
    jQuery(this).toggleClass('active');
});


jQuery(document).on('click', '.banner-langs-select .lang-box-list li', function () {
    const $this = jQuery(this);
    const lang_box = $this.closest('.banner-langs-select').find('.lang-box');
    
    var url = $this.attr('data-url');
    var name = $this.attr('data-name');
    
    lang_box.attr('data-url', url);
    lang_box.find('span.text').text(name);
    lang_box.removeClass('active'); 
});


jQuery(document).on('click', '.banner-langs-select #continue', function () {
    const lang_box = jQuery('.banner-langs-select .lang-box');
    $redirect_url = lang_box.attr('data-url');
    window.location.href = $redirect_url;
});

jQuery(document).on('click', '.banner-langs-select #close', function () {
    jQuery('.banner-langs-select').remove();
    set_banner_header_spacing();
    setLangBannerSession();
});

function setLangBannerSession($redirect_url = '') {
    jQuery.ajax({
        type: "POST",
        dataType: 'json',
        url: ajax_marketing_theme.ajaxurl,
        data: {
            action: "banner_set_session",
        },
        success: function (data) {
        }
    });
}


banner_countdown = function () {
    if (jQuery('.banner-countdown').length && jQuery('#banner_countdown').length) {
        setTimeout(function () {
            jQuery('#banner_countdown').prepend(jQuery('.banner-countdown'));

            // jQuery('.banners-placeholder').height(header_height);
            // if (jQuery('.banner-countdown__wrapper').length) {
            //     jQuery('.banner-countdown__wrapper').get(0).style.setProperty('--infobar-height', header_height + 'px');
            // }
        }, 200);
    }
}